import { bookingBoxBind } from '@/modules/shared/product/booking';

export const showBookingPanel = function () {
    bookingBoxBind(false);
    jm('#bookingPanelTriggle').data('pid', -1);
    jm('#bookingPanelTriggle').trigger('click');
};
